import request from '@/utils/request'

export function loginWithCandidate(data) {
  return request({
    url: '/portal-api/zhongyi/auth/login',
    method: 'POST',
    data
  })
}

export function fetchScoreList() {
  return request({
    url: '/portal-api/zhongyi/score/list',
    method: 'GET'
  })
}

export function fetchScoreDetail(candidateId) {
  return request({
    url: '/portal-api/zhongyi/score/detail',
    method: 'GET',
    params: {
      candidateId
    }
  })
}

export function fetchCertificateDetail(certNo) {
  return request({
    url: '/portal-api/zhongyi/certificate/detail',
    method: 'GET',
    params: {
      certNo
    }
  })
}
